import router from './router';
import store from './store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { Message } from 'element-ui';
import { getToken } from '@/utils/auth';

router.beforeEach(async (to, from, next) => {
  NProgress.start();

  if (!getToken()) {
    if (store.getters.routesLoaded) {
      await store.dispatch('ResetRoutes');
    }
    if (to.path === '/login') {
      next();
    } else {
      next('/login');
      NProgress.done();
    }
    return;
  }

  // 被兜底路由重定向时仍检查原地址，避免刷新深链接后丢失目标页面。
  const target = to.redirectedFrom || to.fullPath;
  const targetPath = target.split(/[?#]/)[0].replace(/\/+$/, '') || '/';

  if (!store.getters.routesLoaded) {
    try {
      const response = await store.dispatch('GetInfo');
      await store.dispatch('GenerateRoutes', { menus: response.data.menus });
      router.addRoutes(store.getters.addRouters);
      // 按新路由表重新匹配地址，不能复用旧的 matched/name。
      next({ path: target, replace: true });
    } catch (error) {
      await store.dispatch('FedLogOut');
      Message.error('登录状态校验失败，请重新登录');
      next('/login');
      NProgress.done();
    }
    return;
  }

  if (targetPath === '/' || targetPath === '/login') {
    next({ path: store.getters.landingPath, replace: true });
  } else if (
    /^\/home(?:\/|$)/i.test(targetPath) &&
    !store.getters.hasDashboard
  ) {
    // 侧边栏隐藏不能代替访问控制，旧首页地址和仪表盘深链接都必须验证权限。
    next({ path: '/403', replace: true });
  } else {
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});



// WEBPACK FOOTER //
// ./src/permission.js